// extracted by mini-css-extract-plugin
module.exports = {"mainSwiper":"gallery_mainSwiper__AdSmi","thumbSwiper":"gallery_thumbSwiper__7YOB7"};